import React, { useState, useEffect, useCallback } from "react";
import { globalVars } from "../global/GlobalVars.js";
import axios from "axios";
import * as language from "./language.js";
import * as websocket from "./communication.js";

//========================================================================
// Funktion zum Seiten aufrufen
const loadPageConfig = (page, isBack) => {
  if (page === "startpage") {
    globalVars.setStartpageLoaded(true);
  } else {
    globalVars.setStartpageLoaded(false);
  }

  // IP-Adresse des Servers
  let url = window.location.hostname;

  const fetchPageConfig = async () => {
    if (!page) return;
    try {
      const url =
        window.location.port === "3000"
          ? `http://${window.location.hostname}:${globalVars.httpPort}/project/pages/${page}.json`
          : `/project/pages/${page}.json`;
      const response = await axios.get(url);
      let pageConfig = response.data;

      // mobile auf false setzen wenn nicht definiert
      if (pageConfig.mobile === undefined) pageConfig.mobile = false;

      // Reihenfolge erzwingen
      const { elements, ...config } = pageConfig;

      pageConfig = {
        ...config,
        mobile: pageConfig.mobile,
        elements: elements,
      };

      const newPageProperties = {
        // Seitenkonfiguration
        currentPageConfig: pageConfig,
        // Sichtbarkeit Buttons Vorwärts und Rückwärts
        showButtonNavigateForward: pageConfig.forward ? true : false,
        showButtonNavigateBackward: pageConfig.backward ? true : false,
        actualPath: page,
      };

      // Seitenkonfiguration in globale Variable schreiben
      globalVars.setPageProperties(newPageProperties);

      // Seitenhistorie
      const newPageHistory = isBack
        ? globalVars.pageHistory.slice(0, -1)
        : [...globalVars.pageHistory, page];

      // Seitenhistorie in globale Variable schreiben
      globalVars.setPageHistory(newPageHistory);

      // Namen im Browser-Tab aktualisieren
      document.title = language.displayText(pageConfig.pageTitle) /*+
        " (" +
        globalVars.activeAlarms.length.toString() +
        language.displayText([" Alarme)", " allarmi)", " alarms)"])*/;

      // alte Datenpunkte abmelden
      globalVars.setReqDataValues([]);
      websocket.registerDataPoints(
        globalVars.ws,
        globalVars.reqDataValues,
        "unregister",
      );
    } catch (err) {
      // console.error("Fehler beim Laden der Konfigurationsdatei", err);
    }
  };

  fetchPageConfig();
};

//========================================================================
// Funktion zum Seitenwechsel
const changePage = (mode, customPath) => {
  switch (mode) {
    case "login":
      loadPageConfig("__system/login", false);
      break;
    case "home":
      // ========== Navigation zur Startseite ==========
      if (globalVars.auth.loggedIn) {
        if (!globalVars.mobile) {
          loadPageConfig(globalVars.startpage, false);
        } else {
          loadPageConfig(globalVars.startpageMobile, false);
        }
      }
      break;
    case "homeMobile":
      // ========== Navigation zur mobilen Startseite ==========
      if (globalVars.auth.loggedIn) {
        loadPageConfig(globalVars.startpageMobile, false);
      }
      break;
    case "back":
      // ========== Navigation zur vorherigen Seite ==========
      if (globalVars.auth.loggedIn) {
        if (globalVars.pageHistory.length > 1) {
          let lastPage =
            globalVars.pageHistory[globalVars.pageHistory.length - 2];
          loadPageConfig(lastPage, true);
        }
      }
      break;
    case "forward":
      // ========== Navigation Vorwärts ==========
      if (globalVars.auth.loggedIn) {
        loadPageConfig(
          globalVars.pageProperties.currentPageConfig.forward,
          false,
        );
      }
      break;
    case "backward":
      // ========== Navigation Rückwärts ==========
      if (globalVars.auth.loggedIn) {
        loadPageConfig(
          globalVars.pageProperties.currentPageConfig.backward,
          false,
        );
      }
      break;
    case "alarm":
      // ========== Navigation zur Alarmseite ==========
      if (globalVars.auth.loggedIn) {
        loadPageConfig("__system/alarm", false);
      }
      break;
    case "alarmMobile":
      // ========== Navigation zur Alarmseite ==========
      if (globalVars.auth.loggedIn) {
        loadPageConfig("__system/alarmMobile", false);
      }
      break;
    case "custom":
      // ========== neue Seite aufrufen über Link ==========
      if (globalVars.auth.loggedIn) {
        loadPageConfig(customPath, false);
      }
      break;
    default:
      break;
  }
};

//========================================================================
// Funktionen exportieren
export { loadPageConfig, changePage };
